const BgSlash=()=> {
  return <div className="bg_slash">
          <img src="https://towershibuya.jp/assets/images/svg/bg_slash.svg" alt="slash"/>
        </div>
}

export default BgSlash;
